import React, {useState} from 'react';
import {Collapse, Button} from 'reactstrap';
import arrowDownUpIcon from '../images/arrow-down-up/arrow-down-up.svg';
import arrowDownUpIcon2x from '../images/arrow-down-up/arrow-down-up@2x.svg';
import arrowDownUpIcon3x from '../images/arrow-down-up/arrow-down-up@3x.svg';
import infoIcon from '../images/info/info.svg';
import infoIcon2x from '../images/info/info@2x.svg';
import infoIcon3x from '../images/info/info@3x.svg';
import Image from 'app/Components/Shared/Image/image';

const arrowDownUpIcons = [arrowDownUpIcon, arrowDownUpIcon2x, arrowDownUpIcon3x];
const infoIcons = [infoIcon, infoIcon2x, infoIcon3x];

const CustomerItemComponent = (props) => {
  const {checked, id, number, name, onToggleCheckBox, isSelecting, subcustomers, searchValue = '', filtering, propsUpdateSlice} = props;
  const [collapse, setCollapse] = useState(false);
  const toggle = () => setCollapse(!collapse);

  let separetedNumber = {styled: '', regular: number};
  let separetedName = {styled: '', regular: name};

  if (filtering && searchValue.trim() != '') {
    if (number?.includes(searchValue)) {
      let subStr = number.substring(searchValue.length);
      separetedNumber = {styled: searchValue, regular: subStr};
    } else {
      let subStr = name.substring(searchValue.length);
      separetedName = {styled: searchValue, regular: subStr};
    }
  }


  const backgroundImageFromIcons = (icons) => {
    const dpr = window.devicePixelRatio || 1;
    if (dpr >= 3) {
      return icons[2];
    }
    if (dpr >= 2) {
      return icons[1];
    }
    return icons[0];
  };
  
  return (
    <>
      <div className='customer-item'>
        <div
          className={`${name == '' || !name ? 'only-number' : ''} custom-control custom-checkbox ${isSelecting ? 'active' : ''} ${
            !propsUpdateSlice?.data.isBusinessBlock ? 'd-flex flex-column' : ''
          }`}>
          <input
            type='checkbox'
            className='custom-control-input'
            checked={checked ? 'checked' : ''}
            id={id}
            onChange={() => {
              onToggleCheckBox(id);
            }}
          />

          <label className={`custom-control-label ${!propsUpdateSlice?.data.isBusinessBlock ? 'w-50 mb-4' : ''}`} htmlFor={id}>
            <span className='d-block number'>
              <span className='bold pink-text'>{separetedNumber.styled}</span>
              <span className='bold'>{separetedNumber.regular}</span>
            </span>
            {name && name != '' && (
              <span className='d-block customer-name'>
                <span className='bold pink-text'>{separetedName.styled}</span>
                <span>{separetedName.regular}</span>
              </span>
            )}
          </label>
          {subcustomers?.length > 0 && <Button color='link' style={{ backgroundImage: backgroundImageFromIcons(arrowDownUpIcons).bg() }} onClick={toggle} className={`${collapse ? 'opened' : ''}`}></Button>}
        </div>
      </div>

      {subcustomers?.length > 0 && (
        <Collapse isOpen={collapse} className='paid-up'>
          <p className='paid-up-text'><Image src={backgroundImageFromIcons(infoIcons)} alt="info" className="info-icon" />אלה החשבונות המשניים לחשבון הראשי - עדכון אמצעי תשלום לחשבון הראשי יהיה תקף גם לגביהם</p>
          {subcustomers.map((sub) => (
            <div className='paid-up-item d-block' key={sub.id}>
              <span className='d-block bold'>{sub.number}</span>
              <span className='d-block customer-name'>{sub.name}</span>
            </div>
          ))}
        </Collapse>
      )}
    </>
  );
};
export default CustomerItemComponent;
